<template>
    <layout-main :banner="banner" subtitle="婴儿防盗系统">
        <template v-slot:content>
            <p class="text">迪孚婴儿防盗解决方案基于迪孚定位系统平台，旨在提高医院新生儿安全保护。当病区内的新生儿被非法抱离病区，与母亲标签配对信息有误，非法剪断婴儿标签腕带时都会及时发出告警，让护士及时有效的处理，保障新生儿在院内的安全，防止因监护疏忽出现的婴儿抱错，非法抱离医院等情况出现。</p>
            <img src="@/assets/baby/image1.png" alt="" class="image1">
            <div class="title weight"> 产品特征 </div>
            <p class="text weight">· 穿透性：穿透性强，可穿透墙体，可穿透任何金属汽车防爆膜</p>
            <p class="text weight">· 读写速度快：与条码相比，无须直线对准扫描，读写速度更快，可多目标识别、运动识别</p>
            <p class="text weight">· 防拆防剪：具备拆卸报警，剪断腕带报警功能</p>
            <p class="text weight">· 安全性：专用芯片、序列号惟一、很难复制</p>
            <p class="text weight">· 耐用性：无机械故障、全密封结构抗恶劣环境</p>
           
        </template>
    </layout-main>
</template>
<script>
import layoutMain from '@/components/layout-main.vue'
import banner from '@/assets/baby/banner.png'
export default {
    components: {
        layoutMain,
        
    },
    data () {
        return {
            banner: banner
        }
    }
}
</script>
<style lang="scss" scoped>
  .weight{
      font-weight: 600;
      line-height: 3 !important;
  }
  .title{ 
      text-indent: 1.5em;
      font-size: 25px;
      text-align: left;
      margin: 20px 0;
  }
  .text{
      line-height: 2;
  }
  .image1{
      width: 100%;
      margin: 50px 0;
  }
</style>
